module.exports = __webpack_public_path__ + "media/bootstrap-icons/cursor-fill-e22c6de3.svg";